/**
 * @generated SignedSource<<af56d888215023aadcaccb5ab2f815a7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type AttendeeWeeklyHoursInMinutesQuery$variables = {
  currentDate: any;
  userId: string;
};
export type AttendeeWeeklyHoursInMinutesQuery$data = {
  readonly user: {
    readonly attendeeWeeklyMeetingHoursLimit?: number | null;
    readonly weeklyMinutesInMeetings?: number | null;
  } | null;
};
export type AttendeeWeeklyHoursInMinutesQuery = {
  response: AttendeeWeeklyHoursInMinutesQuery$data;
  variables: AttendeeWeeklyHoursInMinutesQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "currentDate"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "userId"
},
v2 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "userId"
  }
],
v3 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "currentDate",
          "variableName": "currentDate"
        }
      ],
      "kind": "ScalarField",
      "name": "weeklyMinutesInMeetings",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "attendeeWeeklyMeetingHoursLimit",
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "AttendeeWeeklyHoursInMinutesQuery",
    "selections": [
      {
        "alias": "user",
        "args": (v2/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "AttendeeWeeklyHoursInMinutesQuery",
    "selections": [
      {
        "alias": "user",
        "args": (v2/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "381c70ab2e586ff5e0da636340a3145c",
    "id": null,
    "metadata": {},
    "name": "AttendeeWeeklyHoursInMinutesQuery",
    "operationKind": "query",
    "text": "query AttendeeWeeklyHoursInMinutesQuery(\n  $userId: ID!\n  $currentDate: Date!\n) {\n  user: node(id: $userId) {\n    __typename\n    ... on User {\n      weeklyMinutesInMeetings(currentDate: $currentDate)\n      attendeeWeeklyMeetingHoursLimit\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "0ff6c3bc25416c78d0302f8aaa491a45";

export default node;
